import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { callaElRuidoDeLasExtensiones } from "@/lib/ruidoDelNavegador.mjs";
import { registraElTrabajador } from "@/lib/trabajador.mjs";

// Antes de nada, y antes que React: el oyente tiene que estar puesto antes de que llegue el
// error. Vivia en un `<script>` del `index.html` y salio de ahi para que la CSP pueda decir
// `script-src 'self'` sin excepciones.
callaElRuidoDeLasExtensiones();
// Para instalarse en el móvil y tener página de «sin conexión». Guarda solo `/static/`.
registraElTrabajador();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
